
export enum GiftCardLogTypeEnum {
  TOPUP,
  TRANSACTION
}
